import { Autocomplete, Card, CircularProgress, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Radio, RadioGroup, Select, Tab, Tabs, TextField, ThemeProvider, createTheme } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import { useDebounce } from 'use-lodash-debounce';
import postOperation, { getAssets, getCustomCategories } from "./api/operationsApi";

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { ptBR } from '@mui/x-date-pickers/locales';
import { useMaterialUIController } from "context";
import dayjs from "dayjs";
import 'dayjs/locale/pt-br';
import { Steps } from "intro.js-react";
import { completeOnboarding, isOnboardingCompleted } from "utils/onboarding";
import { useLocation, useNavigate } from "react-router-dom";
import { APP_OPERATION_EXTRACT_ROUTE, APP_OPERATION_ROUTE } from "utils/routes";
import { OperationsExtractContent } from "./extrato";

const OPERATIONS_ONBOARDING_KEY = "patrimonio360onboarding-novaoperacao";
const REGISTER_TAB = "registrar";
const EXTRACT_TAB = "extrato";

function OperationsLayout() {
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;
    const navigate = useNavigate();
    const location = useLocation();
    const activeTab = location.pathname === APP_OPERATION_EXTRACT_ROUTE ? EXTRACT_TAB : REGISTER_TAB;

    const [assets, setAssets] = useState([]);
    const [categories, setCategories] = useState([]);
    const [asset, setAsset] = useState('');
    const [search, setSearch] = useState('');
    const [quantity, setQuantity] = useState('');
    const [price, setPrice] = useState(null);
    const [operationType, setOperationType] = useState('compra');
    const [date, setDate] = useState(new Date());
    const [stepsEnabled, setStepsEnabled] = useState(false);
    const [screenWidth, setScreenWidth] = useState(null);
    const [openSnackMessage, setOpenSnackMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [enableSelectCategory, setEnableSelectCategory] = useState(false);
    const [customCategoryName, setCustomCategoryName] = useState(null);
    const [customCategory, setCustomCategory] = useState(null);
    const [customCategories, setCustomCategories] = useState([]);
    const [anchorIndexList, setAnchorIndexList] = useState([]);
    const [selectedAnchorIndex, setSelectedAnchorIndex] = useState(null);


    const theme = createTheme(
        {
            palette: {
                primary: { main: '#1976d2' },
            },
        },
        ptBR,
    );

    const debouncedValue = useDebounce(asset, 200);
    const debouncedSearch = useDebounce(search, 200);

    useEffect(() => {
        setScreenWidth(getWindowDimensions().width)

        setStepsEnabled(activeTab === REGISTER_TAB && !isOnboardingCompleted(OPERATIONS_ONBOARDING_KEY));
    }, [activeTab])


    function getWindowDimensions() {
        const { innerWidth: width, innerHeight: height } = window;
        return {
            width,
            height
        };
    }

    useEffect(() => {
        //TODO: aqui chama a API para buscar a posição atual do user;
        getAssetsList();

    }, [, debouncedValue, debouncedSearch]);

    useEffect(() => {
        if ((debouncedSearch?.length > 0 && assets?.length == 0)) {
            setEnableSelectCategory(true);
        } else {
            setEnableSelectCategory(false);
        }

    }, [debouncedSearch, assets]);

    useEffect(() => {
        if (enableSelectCategory) {
            getAssetCustomCategories();
            getAnchorIndex();
        }
    }, [enableSelectCategory]);

    useEffect(() => {
        setCategories([]);
    }, [enableSelectCategory]);

    const getAssetsList = async () => {
        await getAssets(debouncedSearch).then((data) => {
            setAssets(data.results?.map((item) => {
                return {
                    id: item.id,
                    label: item.ticker ?? item.name,
                    type: item.assetTypeId
                };
            }
            ));
        });
    };

    const getAssetCustomCategories = async () => {
        await getCustomCategories(debouncedSearch).then((data) => {
            console.log(data)
            setCustomCategories(data.map((item) => {
                return {
                    id: item.id,
                    label: item.name
                };
            })
            );
        });
    };

    const getAnchorIndex = async () => {

        setAnchorIndexList([
            { id: 1, name: "Euro" },
            { id: 2, name: "Dólar" },
            { id: 3, name: "CDI" },
            { id: 4, name: "Selic" },
        ])
    }

    const handleDateChange = (date) => {
        const formattedDate = dayjs(date).format('YYYY-MM-DD');
        setDate(formattedDate)
    };

    const handleSave = async () => {
        setIsLoading(true);
        // customCategoryName
        const categ = customCategory == null && customCategoryName != null ? {
            id: null,
            name: customCategoryName
        } :
            customCategory != null ?
                customCategory
                : null;

        const body = {
            assetId: assets?.length < 1 ? null : asset?.id,
            customAssetName: search,
            quantity: quantity,
            averagePrice: price,
            operationType: operationType === 'compra' ? 1 : 2,
            operationDate: date,
            category: categ,
            index: selectedAnchorIndex
        };

        await postOperation(body)
            .then((data) => {
                if (data?.errorCode) {
                    setOpenSnackMessage({ type: 'error', message: `${data?.message}`, isUpgradeMessage: data?.errorCode == 402 }); //codigo de erro de tier
                    return;
                }

                setOpenSnackMessage({ type: 'success', message: 'Operação realizada com sucesso' });
            })
            .catch(e => {
                setOpenSnackMessage({ type: 'error', message: `${e}` });
            });

        setIsLoading(false);
    };

    const stepsDesktop = [
        {
            element: '.menu-operation',
            intro: 'No menu "Operações", você pode registrar ativos, bens e movimentações do seu patrimônio.',
        },
        {
            element: '.ativoInput',
            intro: 'Neste campo, você pode procurar um ativo específico ou cadastrar um bem do seu patrimônio.',
            // position: 'right',
            // tooltipClass: 'myTooltipClass',
        },
        {
            element: '.ativoQuantidade',
            intro: 'Neste campo, você deve informar a quantidade referente ao ativo ou bem selecionado.',
        },
        {
            element: '.ativoPreco',
            intro: 'Informe o preço do ativo ou bem cadastrado.'
        },
        {
            element: '.ativoData',
            intro: 'Selecione a data da operação.',
        },
        {
            element: '.opetacaoType',
            intro: 'Escolha o tipo de operação.'
        },
        {
            element: '.salvarOperacao',
            intro: 'Agora é só salvar.'
        }
    ];

    const handleBeforeChange = (nextStepIndex) => {
        if (screenWidth < 1200 && nextStepIndex == 0) {
            setTimeout(() => {
                document.getElementsByClassName("menuHamburger")[0].click()

            }, 100);
        }

        if (screenWidth < 1200 && nextStepIndex == 1) {
            document.getElementsByClassName("menuHamburger")[0].click()
        }
    };

    const handleCloseOnboarding = () => {
        completeOnboarding(OPERATIONS_ONBOARDING_KEY);
        setStepsEnabled(false);
    };

    const handleTabChange = (_event, nextTab) => {
        navigate(nextTab === EXTRACT_TAB ? APP_OPERATION_EXTRACT_ROUTE : APP_OPERATION_ROUTE);
    };

    return (
        <DashboardLayout>
            <Steps
                enabled={stepsEnabled && activeTab === REGISTER_TAB}
                steps={stepsDesktop}
                initialStep={0}
                onExit={handleCloseOnboarding}
                onBeforeChange={handleBeforeChange}
                onBeforeExit={false}
                exitOnOverlayClick={false}
                onComplete={handleCloseOnboarding}
                options={{
                    doneLabel: 'Entendi!',
                    prevLabel: '<',
                    nextLabel: '>'
                }}
            />
            <DashboardNavbar />
            <Grid item xs={12} sm={6} lg={3}>
                <MDSnackbar
                    color={openSnackMessage?.type}
                    icon="check"
                    title={openSnackMessage?.message}
                    open={openSnackMessage}
                    isUpgradeMessage={openSnackMessage?.isUpgradeMessage}
                    onClose={() => setOpenSnackMessage(false)}
                    close={() => setOpenSnackMessage(false)}
                />
            </Grid>
            <MDBox pt={6} pb={3}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox px={2} py={1}>
                                <Tabs
                                    value={activeTab}
                                    onChange={handleTabChange}
                                    variant="fullWidth"
                                    aria-label="Abas da página de operações"
                                >
                                    <Tab value={REGISTER_TAB} label="Registrar" />
                                    <Tab value={EXTRACT_TAB} label="Extrato" />
                                </Tabs>
                            </MDBox>
                        </Card>
                    </Grid>
                    {activeTab === REGISTER_TAB ? (
                        <Grid item xs={12}>
                            <Card>
                                <StyledMDBox
                                    mx={2}
                                    mt={0}
                                    py={3}
                                    px={2}
                                    variant="gradient"
                                    bgColor="info"
                                    borderRadius="lg"
                                    coloredShadow="info"
                                >
                                    <MDTypography variant="h6" color="dark">
                                        Registrar operação
                                    </MDTypography>
                                </StyledMDBox>
                                <MDBox pt={4} pb={3} px={3} >
                                    <MDBox component="form" role="form">
                                    <StyledInput mb={2} id="input-ativo" className="ativoInput">
                                        <Autocomplete data-input
                                            className="input-ativox"
                                            freeSolo
                                            options={assets}
                                            getOptionLabel={option => option.label}
                                            onChange={(e, newValue) => {
                                                setAsset(newValue);
                                            }
                                            }
                                            renderInput={(params) => <TextField  {...params}
                                                onChange={(e) => setSearch(e.target.value)}
                                                label="Ativo" />}
                                        />
                                    </StyledInput>

                                    {enableSelectCategory &&
                                        <StyledInput mb={2} id="input-category" className="ativoInput">
                                            <Autocomplete data-input
                                                className="input-category"
                                                freeSolo
                                                options={customCategories}
                                                getOptionLabel={option => option.label}
                                                onChange={(e, newValue) => setCustomCategory(newValue)}
                                                renderInput={(params) => <TextField  {...params}
                                                    onChange={(e) => setCustomCategoryName(e.target.value)}
                                                    label="Categoria" />}
                                            />
                                        </StyledInput>
                                    }

                                    {enableSelectCategory &&
                                        <StyledFormControl fullWidth >
                                            <InputLabel id="demo-simple-select-label">Indexador</InputLabel>
                                            <StyledSelect
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={selectedAnchorIndex}
                                                label="Indexador"
                                                onChange={e => setSelectedAnchorIndex(e.target.value)}
                                            >
                                                {anchorIndexList?.map((e, key) => {
                                                    return (<MenuItem value={e.id}>{e.name}</MenuItem>)

                                                })}
                                            </StyledSelect>
                                        </StyledFormControl>
                                    }
                                    <MDBox mb={2} className="ativoQuantidade">
                                        <MDInput type="number"
                                            label="Quantidade"
                                            fullWidth
                                            value={quantity}
                                            onChange={(e) => setQuantity(e.target.value)} />
                                    </MDBox>
                                    <MDBox mb={2} className="ativoPreco">
                                        <MDInput type="number" label="Preço" fullWidth
                                            value={price}
                                            onChange={(e) => setPrice(e.target.value)} />
                                    </MDBox>
                                    <ThemeProvider theme={theme}>
                                        <LocalizationProvider
                                            adapterLocale="pt-br"
                                            dateAdapter={AdapterDayjs}
                                        >
                                            <StyledDatePicker $isDarkTheme={darkMode} className="ativoData"
                                                defaultValue={dayjs(new Date())}
                                                sx={{
                                                    display: 'flex', justifyContent: 'flex-end',
                                                }}
                                                // format="DD/MM/YYYY" 
                                                label="Data da operação"
                                                onChange={handleDateChange}
                                                PopperProps={{
                                                    modifiers: [
                                                        {
                                                            name: 'offset',
                                                            options: {
                                                                offset: [0, 10], // Deslocamento para ajustar a posição
                                                            }
                                                        }
                                                    ]
                                                }}

                                            />
                                        </LocalizationProvider>
                                    </ThemeProvider>
                                    <MDBox mb={2} className="opetacaoType">
                                        <RadioGroup
                                            aria-labelledby="demo-radio-buttons-group-label"
                                            defaultValue="compra"
                                            name="radio-buttons-group"
                                            row
                                            onChange={(e) => setOperationType(e.target.value)}
                                        >
                                            <FormControlLabel value="compra" control={<Radio />} label="Compra" />
                                            <FormControlLabel value="venda" control={<Radio />} label="Venda" />
                                        </RadioGroup>
                                    </MDBox>
                                    <MDBox display="flex" alignItems="center" ml={-1}>

                                    </MDBox>
                                    <MDBox mt={4} mb={1} className="salvarOperacao">
                                        <MDButton disabled={isLoading} variant="gradient" color="info" fullWidth onClick={handleSave}>
                                            {isLoading
                                                ?
                                                <CircularProgress color="inherit" size={16} />
                                                : <>
                                                    Salvar
                                                </>}
                                        </MDButton>
                                    </MDBox>

                                    </MDBox>
                                </MDBox>
                            </Card>
                        </Grid>
                    ) : (
                        <Grid item xs={12}>
                            <OperationsExtractContent />
                        </Grid>
                    )}
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout >
    );
}

const StyledMDBox = styled(MDBox)`
  background: radial-gradient(circle at 221% 201%, #f28371 0%, #f28371 65%, transparent 0%) ,#f0ba8d !important; 
`;

const StyledInput = styled(MDBox)`
[data-input] {
    & > div > div {
        // border: 1px solid red;
        height: 44px;
        
        & > input {
            padding: 0 5px !important;
        }
    }
}
`;

const StyledDatePicker = styled(DatePicker)`
    width: 100%;

    &>div{
        border-radius: 8px;
        height: 43px;
        padding: 0 3px;
    }

    input{
        padding: 9px 10px;
        font-size: 14px;
        color: rgb(73, 80, 87);
    }

    label{
        font-size: 14px;
        top: -4px;
    }

    button{
        right: 10px
    }


    ${({ $isDarkTheme }) =>
        css` 
        label{
            color: ${$isDarkTheme ? '#FFFFFFCC' : '#7B809A'};
        }    

        div {
            height: 44.5px;
            border-bottom-left-radius: 6px;
            border-bottom-right-radius: 6px;
            border-top-left-radius: 6px;
            border-top-right-radius: 6px;

            &:hover fieldset {
                border-color: ${$isDarkTheme ? 'rgba(210, 214, 218, 0.6)' : '#d2d6da'} !important;
              }

              input {
                color: ${$isDarkTheme ? '#FFFFFFCC' : '#7B809A'};
              }
          
            fieldset{
                border-top-color: ${$isDarkTheme ? 'rgba(210, 214, 218, 0.6)' : '#d2d6da'};
                border-bottom-color: ${$isDarkTheme ? 'rgba(210, 214, 218, 0.6)' : '#d2d6da'};
                border-right-color: ${$isDarkTheme ? 'rgba(210, 214, 218, 0.6)' : '#d2d6da'};
                border-left-color: ${$isDarkTheme ? 'rgba(210, 214, 218, 0.6)' : '#d2d6da'};
            }

            path{
                color: ${$isDarkTheme ? '#FFFFFFCC' : '#7B809A'};
            }
        } 
    `}
`;

const StyledFormControl = styled(FormControl)`
    top: -1px;
    @media screen and (max-width: 900px) {
        top: 0;
      }
`;

const StyledSelect = styled(Select)`
    padding: 12px;
    margin-bottom: 12px;
`;

export default OperationsLayout;
